import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";

export const formFecha = (fecha) => {
    return formatDistanceToNow(new Date(fecha), { addSuffix: true, locale: es })
}

// Formatea la fecha al formato "mes año" en español
export const formatearFecha = (date) => {
    return date.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "long",
    });
  };